import type { RegisterOptions } from "react-hook-form";

export const emailRules: RegisterOptions = {
  required: "Email is required",
  pattern: {
    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    message: "Please enter a valid email address",
  },
};

export const passwordRules: RegisterOptions = {
  required: "Password is required",
  validate: (val: string) => {
    if (val.length < 8) return "At least 8 characters";
    if (!/[A-Z]/.test(val)) return "Include an uppercase letter";
    if (!/[0-9]/.test(val)) return "Include a number";
    return true;
  },
};

export const textRules: RegisterOptions = {
  required: "This field is required",
  validate: (val: string) => {
    const trimmedVal = val?.trim();
    if (!trimmedVal) return "This field is required";
    return true;
  },
};

export const einRules: RegisterOptions = {
  required: "EIN is required",
  validate: (val: string) => {
    const trimmedVal = val?.trim();
    if (!trimmedVal) return "EIN is required";
    const einPattern = /^\d{2}-\d{7}$/;
    if (!einPattern.test(trimmedVal)) {
      return "Please enter a valid EIN format (XX-XXXXXXX)";
    }
    return true;
  },
};

export const urlRules: RegisterOptions = {
  required: "URL is required",
  validate: (val: string) => {
    const trimmedVal = val?.trim();
    if (!trimmedVal) return "URL is required";
    const urlPattern = /^https?:\/\/(?:[-\w.])+(?:\:[0-9]+)?(?:\/(?:[\w/_.])*(?:\?(?:[\w&=%.])*)?(?:\#(?:[\w.])*)?)?$/;
    if (!urlPattern.test(trimmedVal)) {
      return "Please enter a valid URL (e.g., https://example.com)";
    }
    return true;
  },
};

export const checkboxRules: RegisterOptions = {
  required: "You must accept the terms and conditions",
  validate: (value: boolean) => value || "You must accept the terms and conditions",
}
